
import { HttpResponse } from "../auth/AuthInterface";
import { UnidadProps } from "./UnidadInterface";
import { UbicacionProps } from "./UbicacionInterface";
import { TurnoTipoProps } from "./TurnoTipoInterface";
import { TurnoEstadoProps } from "./TurnoEstadoInterface";

// Definición de defaults

export const defaultTurno: TurnoProps = {
    turno_id: 0,
    turno_numero: 0,
    turno_estado: {
        id: 0,
        nombre: '',
    },
    turno_tipo: {
        id: 0,
        nombre: '',
    },
    turno_comentarios: '',
    turno_fecha: '',
    turno_telefono: '',
    ubicacion: {
        id: 0,
        nombre: '',
        numero: 0,
    },
    unidad: {
        id: 0,
        clave: '',
        nombre: '',
    }                          
}

// Creación de interfaces

export interface TurnoProps {
    turno_id:               number;
    turno_numero:           number;
    turno_telefono:         string;
    turno_comentarios:      string;
    turno_fecha:            string;
    unidad:                 UnidadProps;
    ubicacion:              UbicacionProps;
    turno_tipo:             TurnoTipoProps;
    turno_estado:           TurnoEstadoProps;
}

export interface TomarTurnoParams {
    usuario_id:  number;
}

export interface TomarTurnoResponse extends HttpResponse {
    data :  TurnoProps
}

export interface CancelarTurnoParams {
    usuario_id:             number;
    turno_id:               number;
    turno_estado_id:        number;
}

export interface CancelarTurnoResponse extends HttpResponse {
    data :  TurnoProps
}

export interface ConcluirTurnoParams {
    usuario_id:  number;
    turno_id:               number;
    turno_estado_id:        number;
}

export interface ConcluirTurnoResponse extends HttpResponse {
    data :  TurnoProps
}

export interface ActualizarTurnoParams {
    idTurno:            number;
    idTurnoEstado:      number;
    numeroCubiculo:     number;
}